module.exports = __webpack_public_path__ + "Server-Unknown-Ssh.9c11c857dd49825e0221323c00fcb345.hashedasset.svg";